import React from 'react';
import lassra from '../assets/img/lasrra-logo.png';

function LassraLogo(props) {
  return <img alt="lasrra-logo" src={lassra} width={150} {...props} />;
}

export default LassraLogo;
